import { type AccountCampaignSlug, isAccountCampaignActive } from "@/entities/accountCampaign"
import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    account: graphql(
        `
            fragment hasAccountCampaign_Account on AccountType {
                campaigns {
                    ...isAccountCampaignActive_AccountCampaign
                }
            }
        `,
        [isAccountCampaignActive.fragments.accountCampaign]
    ),
}

export function hasAccountCampaign(
    fragment: FragmentOf<typeof graphQLFragments.account>,
    campaignSlug: AccountCampaignSlug
) {
    const account = readFragment(graphQLFragments.account, fragment)

    return !!account.campaigns?.some(
        (accountCampaign) =>
            accountCampaign && isAccountCampaignActive(accountCampaign, campaignSlug)
    )
}

hasAccountCampaign.fragments = graphQLFragments
